var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "a",
      {
        staticClass: "stripe-connect",
        class: _vm.styleType,
        attrs: { href: _vm.connectLink, target: "_blank" },
      },
      [_c("span", [_vm._v(_vm._s(_vm.description))])]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }